export default __webpack_public_path__ + "static/media/draw.00ffce26.svg";